export { default as TableModal } from './TableModal';
export type {
    TableModalConfig,
    TableModalProps,
    TableProps,
} from './TableModal.types';
